import { useEffect } from 'react';
import { useResetRecoilState, useSetRecoilState } from 'recoil';

import { SiteNumberFunc } from '@ecp/common/src/const/site/siteNumberConst';

import { gnbTitleState, gnbTypeState } from '@mo-recoil/common/gnb/atom';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';

export const useGnb = (type) => {
  const gnbType = useSetRecoilState(gnbTypeState);
  const resetGnbType = useResetRecoilState(gnbTypeState);

  useEffect(() => {
    gnbType(type);
    return () => resetGnbType();
  }, [type, gnbType, resetGnbType]);
};

export const useGnbTitle = (title) => {
  const gnbTitle = useSetRecoilState(gnbTitleState);
  const resetGnbTitle = useResetRecoilState(gnbTitleState);
  const { siteNumber } = useSiteInfo();

  /**
   * ECMJ 프로그램 아이디 : PRG_SBABY_01_01
   * 작업자 : 강기단
   * 주문페이지, 주문완료 페이지 타이틀 변경
   */
  if (title === '주문결제' && SiteNumberFunc.paymentName(siteNumber)) {
    title = SiteNumberFunc.paymentName(siteNumber);
  } else if (title === '주문완료' && SiteNumberFunc.completeName(siteNumber)) {
    title = SiteNumberFunc.completeName(siteNumber);
  }

  useEffect(() => {
    gnbTitle(title);
    return () => resetGnbTitle();
  }, [title, gnbTitle, resetGnbTitle]);
};
